// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./plugins/worker/web_client/stylesheets/jobDetailsWidget.styl
// module id = 13
// module chunks = 0